function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Waypoint } from 'react-waypoint';
import { Map } from 'immutable';
import { selectFields, selectInferredField } from '../../../reducers/collections';
import { VIEW_STYLE_LIST, VIEW_STYLE_GRID } from '../../../constants/collectionViews';
import EntryListingGrid from './EntryListingGrid';
import EntryListingTable from './EntryListingTable';
import { jsx as ___EmotionJSX } from "@emotion/react";
export default class EntryListing extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "hasMore", () => {
      var _this$props$cursor;
      const hasMore = (_this$props$cursor = this.props.cursor) === null || _this$props$cursor === void 0 || (_this$props$cursor = _this$props$cursor.actions) === null || _this$props$cursor === void 0 ? void 0 : _this$props$cursor.has('append_next');
      return hasMore;
    });
    _defineProperty(this, "handleLoadMore", () => {
      if (this.hasMore()) {
        this.props.handleCursorActions('append_next');
      }
    });
    _defineProperty(this, "inferFields", collection => {
      const titleField = selectInferredField(collection, 'title');
      const descriptionField = selectInferredField(collection, 'description');
      const imageField = selectInferredField(collection, 'image');
      const fields = selectFields(collection);
      const inferredFields = [titleField, descriptionField, imageField];
      const remainingFields = fields && fields.filter(f => inferredFields.indexOf(f.get('name')) === -1);
      return {
        titleField,
        descriptionField,
        imageField,
        remainingFields
      };
    });
    _defineProperty(this, "renderEntriesForSingleCollection", () => {
      const {
        collections,
        entries,
        viewStyle
      } = this.props;
      const inferredFields = this.inferFields(collections);
      const entriesData = entries.map(entry => {
        return _objectSpread(_objectSpread({}, entry.toJS()), {}, {
          descriptionFieldName: inferredFields.descriptionField,
          imageFieldName: inferredFields.imageField,
          titleFieldName: inferredFields.titleField
        });
      });
      if (viewStyle === VIEW_STYLE_LIST) {
        return ___EmotionJSX(EntryListingTable, {
          entries: entriesData
        });
      }
      if (viewStyle === VIEW_STYLE_GRID) {
        return ___EmotionJSX(EntryListingGrid, {
          entries: entriesData
        });
      }
    });
    _defineProperty(this, "renderEntriesForMultipleCollections", () => {
      const {
        collections,
        entries,
        viewStyle
      } = this.props;
      const isSingleCollectionInList = collections.size === 1;
      let entriesData;
      if (isSingleCollectionInList) {
        entriesData = entries.map(entry => {
          const inferredFields = this.inferFields(collections.first());
          return _objectSpread(_objectSpread({}, entry.toJS()), {}, {
            descriptionFieldName: inferredFields.descriptionField,
            imageFieldName: inferredFields.imageField,
            titleFieldName: inferredFields.titleField
          });
        });
      } else {
        entriesData = entries.map(entry => {
          const collectionName = entry.get('collection');
          const collection = collections.find(c => c.get('name') === collectionName);
          const collectionLabel = collection.get('label_singular') || collection.get('label');
          const inferredFields = this.inferFields(collection);
          return _objectSpread(_objectSpread({
            collection
          }, entry.toJS()), {}, {
            descriptionFieldName: inferredFields.descriptionField,
            imageFieldName: inferredFields.imageField,
            titleFieldName: inferredFields.titleField,
            collectionLabel
          });
        });
      }
      if (viewStyle === VIEW_STYLE_LIST) {
        return ___EmotionJSX(EntryListingTable, {
          entries: entriesData,
          isSingleCollectionInList: isSingleCollectionInList
        });
      }
      if (viewStyle === VIEW_STYLE_GRID) {
        return ___EmotionJSX(EntryListingGrid, {
          entries: entriesData,
          isSingleCollectionInList: isSingleCollectionInList
        });
      }
    });
  }
  render() {
    const {
      collections,
      page
    } = this.props;
    return ___EmotionJSX(React.Fragment, null, Map.isMap(collections) ? this.renderEntriesForSingleCollection() : this.renderEntriesForMultipleCollections(), this.hasMore() && ___EmotionJSX(Waypoint, {
      key: page,
      onEnter: this.handleLoadMore
    }));
  }
}
_defineProperty(EntryListing, "propTypes", {
  collections: ImmutablePropTypes.iterable.isRequired,
  entries: ImmutablePropTypes.list,
  viewStyle: PropTypes.string,
  cursor: PropTypes.any.isRequired,
  handleCursorActions: PropTypes.func.isRequired,
  page: PropTypes.number
});